import { createFileRoute } from "@tanstack/react-router";
import { PlaygroundChatLayout } from "@/app/playground/chat/chat";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/playground/chat/"
)({
  component: PlaygroundChatLayout,
});
